import { Drawer, Tabs } from "antd";
import PolicyHistory from "./PolicyHistory";
import ReviewPolicy from "./ReviewPolicy";

/**
 * Everything that configures review, off the main screen.
 *
 * Open to every reviewer, editable only by an administrator. That split is
 * deliberate: you cannot ask someone to review to a standard they are not
 * allowed to read, but changing what the whole trial treats as material is an
 * accountable act. `ReviewPolicy` gates its own editor on `can_edit` from the
 * API, so read-only access needs nothing here.
 */
export default function ReviewSettingsDrawer({
  trialId,
  open,
  onClose,
}: {
  trialId: string;
  open: boolean;
  onClose: () => void;
}) {
  return (
    <Drawer
      title="Review settings"
      placement="right"
      width={720}
      open={open}
      onClose={onClose}
      destroyOnHidden
    >
      <Tabs
        defaultActiveKey="settings"
        size="small"
        items={[
          {
            key: "settings",
            label: "Review settings",
            children: <ReviewPolicy trialId={trialId} />,
          },
          {
            key: "history",
            label: "Change history",
            children: <PolicyHistory trialId={trialId} />,
          },
        ]}
      />
    </Drawer>
  );
}
